import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/page-template.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Section = makeShortcode("Section");
const TranslatedTitle = makeShortcode("TranslatedTitle");
const ImageClipped = makeShortcode("ImageClipped");
const H1 = makeShortcode("H1");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Section mdxType="Section">
      <TranslatedTitle fr="Bonjour" en="Hello" mdxType="TranslatedTitle" />
      <ImageClipped maskStyle="polygon" opacity="0.12" mdxType="ImageClipped">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "600px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "106.66666666666667%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAACXBIWXMAAAsTAAALEwEAmpwYAAAErElEQVQ4y42UC0yTVxSAbynIRFpqoUUKq5Ep6ARnJEYWcBjFTuoeJgZd2CAmSBTdjIDvmIlDo6ioOIfIgGiY2fABzLlFtimC8TVA5CEWLNDKq+XR0gpF+jhn9/6x0SyI+5Pb3vZ8/3fP+e89PyGvXTP9p5MDqVu4ueLDCJfVMQpeXIySt075OS89IZlIvXz4NMRjcReeG/sk/+taGxPzNoQz8YjrxNTHiyLIp0uWchmsWrrso7A5oWVB8sALEpFP8VRPUZlgsvAgDQlfOt+eXoDEzznlU1GTXCLDOfJAjAidj/NmzkbxFBHSvG7QuPglx3ujLOTdYOLq4u4EAr2miEbSU1NsN0ov2hru3rK1NVTbqn678iJywUIqJV8yyGOSJ3/CDKUCibOMkMTYNWPD3Wp8YewBu8WIz/s7wW7showd25hQyfFTJfw1K1e+IUN5MJEJJc4M39+WmGg1aJ6gdagXRo29MEa/R3TtcPzbvUy4nEG+XlKXCUoOIisWR3FC8eSpCzJ37bCVFebhif37Qf3wHhSd/h72JG+Gc8cO4dfx8UsZtz1pvctn0cvHF84Qy8j57BPcinnHjiqLz5zCk3t3wxcKJVwuyMO0xPWQkpBgz81Ix19yspMYd/74EX5u5nfjC4OnzSDJcXGcMHLuB+HXigrtbXX3sb7qTxjWaUDXWg/NDypt6tq7uDku7hvGZaRupZvyn7Mo9fHmDqjQVUCCAwKdz9B318YNJrYpmqZauHzuR7iYnwsWvcZaceVnfM9Pvo9BSxaGu/LJ5PEzDA2ZR5+dmBMK3EVBs/ymmy+cysI/igphuq8/RswPg5K8HOvqZQq6KfxMxr3j6sGXi/3JpbyzZBJxfyXbuWkTqSy9yDN0tTjPlScFmqNCw7Dw6GFH/tFMKMw6Ahtj19r8PCXoRty3M2hvaqp7xvadvIKTWdxNjfcqCSk8fcJthULh5pTPlQV61VSUr1q8YJFKJpRC3qEMuHP1ElwtOEOFa2zThFJURkUffr06ROQ9rLjO370h6dWfB7alzfq79NK+TtUjNeIoFuefRZnAxxE+OxQPpqXA1vh4kIv9IEg2Ax4/qEJjt7ru1rXSLaujlfLXxaS97n5cXUV5ueqf28Njhi5EywCi1eTQNtWAMjwSRR4ikHlJUOguQMkUb4yNikZTbztQEO0mHapq7gzV3rxeUnX18iecdVjXgS8GOqmnk61Ku0vtMPV2gNXUA8f37AYvFwF6CyQgFfiCr6sYUr5aB47hPjDrNfah3ja7ZeAZWvRaHNSo8GZJ8a+EtpTDatbbWM9SGfTTduvXqsBE26zp7i2cHTCLtRo3JB4SpC8LeK7XgL79MQ5QbtTQDWMmnc1m1jscZj0Sy2AXmHUdnIyWglQIA89acLCzFYf7NNhScwd/yDyMWenpWHWtBEf6tVysr6MZBinH7rWadA46gErtxNDZCs8aaxjABV/CyDJgw0wXsQ31oKVPiwYq0KmbWAVo7GnjeFZRb0s9muhvlhzRNlRjSX6OUV13b4xlaOh6CkzYrarHntYG7HpSh5rGatQ21dL5I+xrb+YypANoyVTW4PgpO+t2zV+/W4a6nuK/DOq8YG+sWzMAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/6649cebd64372c0071e71ad27760f5db/8e964/thomas-morice-transparent.webp 150w", "/static/6649cebd64372c0071e71ad27760f5db/c85cb/thomas-morice-transparent.webp 300w", "/static/6649cebd64372c0071e71ad27760f5db/e88ff/thomas-morice-transparent.webp 600w", "/static/6649cebd64372c0071e71ad27760f5db/131f1/thomas-morice-transparent.webp 900w", "/static/6649cebd64372c0071e71ad27760f5db/92f8c/thomas-morice-transparent.webp 1200w", "/static/6649cebd64372c0071e71ad27760f5db/8c3e9/thomas-morice-transparent.webp 1803w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/webp"
              }}></source>{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/6649cebd64372c0071e71ad27760f5db/8a4e8/thomas-morice-transparent.png 150w", "/static/6649cebd64372c0071e71ad27760f5db/5a46d/thomas-morice-transparent.png 300w", "/static/6649cebd64372c0071e71ad27760f5db/0a47e/thomas-morice-transparent.png 600w", "/static/6649cebd64372c0071e71ad27760f5db/1cfc2/thomas-morice-transparent.png 900w", "/static/6649cebd64372c0071e71ad27760f5db/c1b63/thomas-morice-transparent.png 1200w", "/static/6649cebd64372c0071e71ad27760f5db/be732/thomas-morice-transparent.png 1803w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/png"
              }}></source>{`
        `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/6649cebd64372c0071e71ad27760f5db/0a47e/thomas-morice-transparent.png",
                "alt": "Thomas morice web developer",
                "title": "Thomas morice web developer",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
      `}</picture>{`
    `}</span></p>
      </ImageClipped>
      <H1 mdxType="H1">
  Web Developer
  <br />
  An atypical career path
      </H1>
    </Section>
    <Section mdxType="Section">
      <h2>{`A student in the cloud`}</h2>
      <p>{`Passionate about computers since my childhood, it was late that I found the courage and the confidence to embark on this field`}</p>
      <p>{`Starting with a BTEC First Diploma in microtechnology (Vocational certificate obtained 2 years after the 9th grade), at the Haut-Barr high school of Saverne (France) and a BTEC National in mechanical at the Jules Verne hight school, it was as a chain worker that I started working`}</p>
      <p>{`I was then able to discover the profession of watch repairer, which was fascinating since I was able to prove myself as an attentive worker`}</p>
    </Section>
    <Section mdxType="Section">
      <TranslatedTitle fr="Gendarme" en="Policeman" mdxType="TranslatedTitle" />
      <ImageClipped maskStyle="nonagon" opacity={0.14} mdxType="ImageClipped">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "600px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFFElEQVQ4yy2U6U9cZRTGb9RSlmEWBmaGYZY7+woMOwPMws4AwzZsZWsRKG2hC5RAt1SbulFrtUlbq03URm1STVONH0xDE7+YakxMNPH/+XkG/fDm5t689/c+5znPeRW7aufy1hmefnGP7FA/16/s8smHH3B5e4u9i9ucWj/JZ/fuMD09RkNLA4/uvsdfvx3IesnSwgzeSIitM8v8/vI5vx78gOJ129nZWOPpl/dYWZplPNPF4sQQS+ODvP/WZa7ubrFz7hQun5vG5ga+fXSXf/74hW8e3qGrO4Xq93Lr7V3+fvWCP18doFhtleydP82PTx5x8/I2yZif3oYAKxMD/PTdV+xeOMPk+BDD3QkWsv0cPPmU2/s3OLe6yPJcjkh1mFvXd3jx7DHPH99HUV1O3rm2w1nZsLc6z2x/ks1cPx/trPPzs6/Z2DhFZ0cLyyeWSXV1MS/Kt9ZPcHx6gpFsls3Tq4z0pYm3NrGUy6LEaiPsnF0nUlNNur2FqZ4Ea8PdHB/LcHf/Jg8e3Ofj27c4cWySdEcrVqedcyuL3BArulId7L97g4eXNpjraSMY9KG0JTro6e6mtqGBgVQbw+l2Eo01rM9NMjk9y9LxN5mYmmFhYZ7lqVFCPhdpAeXGxzi3PMf3jz9n/8pFFvpTxKVpSpXbTXc6yZXdizRVBwh4nKIySVtHO4PZUeYXlnCFQnij1YyOj3N6aojt5Vk6RMglAV47lmVmfAS3RyUY8KAUlGhwShkbmxuE6upQQ2FUr4e2ZIKBoSw9/YO4AkHsHo/YUsNob4qudILWeAsnM0kW0o34RbVGr6VUr0Mxqy4CsXqCjU1U+vw45Wd3MIQn4CcgysrNFrSGMkq0WhxOJ6FohNxEjs3FKeYmRogL2GA0YCg3Hu5RHKKo3KliqLJRZrPhi4Spb24h3t6BVqelzGzGWGnFZLNLFv2Yq6z09/exsTjNzMQo4UgQje4/dXanA+WNwiJeLzhKoVaH0e7AIeW6/H7qmpoxWgVkd2KUwyqcLrzVNdhUJ6rHTTQaJFwfo9JmpaikBL2oTKeSKCV6PQUCLSguxuJy4wuHcfq8osaLT0pWvV7CsTrqEyka86s1jku+qY5KGptiYonpUJBWOLX1dXmggSMCLBWf7IEATlFosdtpTqbJTB2jvXeAVim/pa0dm8tFlapSI35PSl5XR3opKCqmUFOKrryc0rIyFI0Aj0qnTeKfXZpRLO+xtgQzp86TXVol1tlLLC4waZ43HDq0o7ktTq1Ao+K31WqiwmrBYLHg9kmwNUYjr+UVVlSgFa9MLg89k6JseBy1JoZTlt0flIN0pDtlxCSfvX29NMXj0iwLLQ1RzFYzZhGUyWRQfAEfjWKux60ymOljcHSE6mQnrvoGjKLKrLrRWyrRyYF5X/Mj2tXdRUIa4FAd1NUEMFSUEa2tke/dKKNyi6zlhogG3KzMT3J1b4f6VJrKcERUmzhaqj18aqUSg0TIFwwQro4SEYDZLhVZzPT09mCTifOLBcqD3U1mU82YTUaSUtJILofF60NjMnOkuETiJFkUf0p0eooEXiWxMQo438y87/ryCnYunCV/J5gl+MqaXDkLmU6M5WWYHE5s4ShaCXIeWCD5Kpcs5oF5WD5aeulmPhX5rpoddqoEsrd94dACrdiiNDfGGJP7rENuCpPXT6VExywTUVxmpPB/oF42Fut0h9D8KtRoOCqDEAr6mRge4vTaGs3SpFI55F8zVKE0apvgUQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/f028076c0424ee7ea5b7484f45635fb6/8e964/thomas-morice-policeman.webp 150w", "/static/f028076c0424ee7ea5b7484f45635fb6/c85cb/thomas-morice-policeman.webp 300w", "/static/f028076c0424ee7ea5b7484f45635fb6/e88ff/thomas-morice-policeman.webp 600w", "/static/f028076c0424ee7ea5b7484f45635fb6/131f1/thomas-morice-policeman.webp 900w", "/static/f028076c0424ee7ea5b7484f45635fb6/92f8c/thomas-morice-policeman.webp 1200w", "/static/f028076c0424ee7ea5b7484f45635fb6/3bff4/thomas-morice-policeman.webp 2379w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/webp"
              }}></source>{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/f028076c0424ee7ea5b7484f45635fb6/8a4e8/thomas-morice-policeman.png 150w", "/static/f028076c0424ee7ea5b7484f45635fb6/5a46d/thomas-morice-policeman.png 300w", "/static/f028076c0424ee7ea5b7484f45635fb6/0a47e/thomas-morice-policeman.png 600w", "/static/f028076c0424ee7ea5b7484f45635fb6/1cfc2/thomas-morice-policeman.png 900w", "/static/f028076c0424ee7ea5b7484f45635fb6/c1b63/thomas-morice-policeman.png 1200w", "/static/f028076c0424ee7ea5b7484f45635fb6/d5682/thomas-morice-policeman.png 2379w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/png"
              }}></source>{`
        `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f028076c0424ee7ea5b7484f45635fb6/0a47e/thomas-morice-policeman.png",
                "alt": "Thomas morice policeman",
                "title": "Thomas morice policeman",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
      `}</picture>{`
    `}</span></p>
      </ImageClipped>
    </Section>
    <Section mdxType="Section">
      <h2>{`Order and discipline`}</h2>
      <p>{`Having successfully passed my open competition exam as a Policeman, I decided to leave my position as a watch repairer to enter police school and start working as a policeman in France`}</p>
      <p>{`'Gendarmerie' in France is a military force. Therefore, the school was pretty constraining, from both a physical and mental perspective. Despite that, I've learned personal commitment, abnegation and the rules of law. Out of school, I joined a police school in Nancy.`}</p>
      <p>{`Some days were more boring than others, and it's during those time that my passion for Web development really rose in me`}</p>
      <p>{`Again pushed to have a new challenge, I decided to quit the police, to start back my studies in computer science`}</p>
    </Section>
    <Section mdxType="Section">
      <TranslatedTitle fr="Études" en="Studies" mdxType="TranslatedTitle" />
      <ImageClipped maskStyle="circle" opacity={0.12} mdxType="ImageClipped">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "600px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "107.33333333333333%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAACXBIWXMAAAsTAAALEwEAmpwYAAADnUlEQVQ4y22VaSu3XRTFry/hDTLPbvM8Zx4yD5kyZMyUcBsSMmYWIZEpkkwlhERJCuU77aff1nFLz4vTuf7XOdfaa6+1zvlbHh4e8nN4enqKl5eXuLu7i4uLizg5OYmjo6MOnl1dXXUfe35/y7B+g7m5uenHvr6+Eh0dLVlZWZKfny95eXmSnp4u4eHhugdwHx8fBeY7M6zfrIKDg+Xv37+yt7cnFxcXcn5+LqenpzrOzs7k6OhI1tfXtYhhy3fMdGQB9ufPHwV0dnaW6upqub6+lqamJunu7pb9/X25vLyU1tZWyc7Olt3dXX03NjamTAMDA3WAkZSU9AXI8Pb21g2hoaHS0dEhcXFxEhMTowW2trakvLxciouLv+eMjAzdT0fsbWxslPb29n8a8hJQPz8/aWlpURYDAwOyvLwsExMTMj09LVdXVyoBa4WFhdoyoJGRkZKZmSmpqan/ACMiInQxJSVF7u/v5fPzU+7u7mR2dlZycnJUho+PD3l9fdW1wcFBNQapQkJCVKLm5uavlo0xbKCV5+dnBZ2bm1OW/f39Mj8/L8fHx8ry/f1d36M5TtMZ8pAEyzhEJVyKjY2V29tbOTg4UHZtbW3KZmhoSLXleWdnR122sbHRtiGDMVFRUWIFBAR8ZwlwfqMFAIeHh5KYmKgOoi2ZXFlZ+Qbv7e2V4eFhmZyclJmZGdnY2BALVCibPGEOoEVFRZo7wk3QHRwcJDc3Vw0iPqWlpVoAM9hDUdq3cKikpERBbW1t9WVYWJjY29sr6OjoqLJMSEjQLOIu4BQHmJNjZ2en68owPj5eq/X09EhXV5eeEp4rKiq0rdXVVVlYWJDx8XHp7OyUtLQ0ZQNYcnKyAuJyXV2djIyMfDEkFlVVVVJZWSk1NTUKyhHj6KEPWuE4muIk3QBKzGgXh+kSYyySTosswJbEQ31tbU02Nzc1KrhKoB8fH+Xk5ET6+vo0zDDDA/KHkZhr8THZent70wuAgHK8MAA3AV1cXNQCS0tLsr29LQ8PD+ounXEDIQ+AyGE9PT3Jzc2NvLy86IE3btFGWVmZNDQ0qBz19fWqU21trUYEaYKCgvSaM1kmWhZiT01N6UnAVYIKIHoQcqriMvEoKChQDWGPPP7+/grEjK56fRlk9ICdOTVUZ6AvM2uwYbBOQYAozszBIMMWyOb6YtGca+MkIWfmt9lrThWGwB5m5oKxzG1tNv78O/gJ8H97YAZjsx+5/gOariph3f6kxwAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/00d8f4372fff335ed36f375e3458a6cb/8e964/thomas-morice-reprise-etudes.webp 150w", "/static/00d8f4372fff335ed36f375e3458a6cb/c85cb/thomas-morice-reprise-etudes.webp 300w", "/static/00d8f4372fff335ed36f375e3458a6cb/e88ff/thomas-morice-reprise-etudes.webp 600w", "/static/00d8f4372fff335ed36f375e3458a6cb/131f1/thomas-morice-reprise-etudes.webp 900w", "/static/00d8f4372fff335ed36f375e3458a6cb/92f8c/thomas-morice-reprise-etudes.webp 1200w", "/static/00d8f4372fff335ed36f375e3458a6cb/3bff4/thomas-morice-reprise-etudes.webp 2379w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/webp"
              }}></source>{`
        `}<source parentName="picture" {...{
                "srcSet": ["/static/00d8f4372fff335ed36f375e3458a6cb/8a4e8/thomas-morice-reprise-etudes.png 150w", "/static/00d8f4372fff335ed36f375e3458a6cb/5a46d/thomas-morice-reprise-etudes.png 300w", "/static/00d8f4372fff335ed36f375e3458a6cb/0a47e/thomas-morice-reprise-etudes.png 600w", "/static/00d8f4372fff335ed36f375e3458a6cb/1cfc2/thomas-morice-reprise-etudes.png 900w", "/static/00d8f4372fff335ed36f375e3458a6cb/c1b63/thomas-morice-reprise-etudes.png 1200w", "/static/00d8f4372fff335ed36f375e3458a6cb/d5682/thomas-morice-reprise-etudes.png 2379w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/png"
              }}></source>{`
        `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/00d8f4372fff335ed36f375e3458a6cb/0a47e/thomas-morice-reprise-etudes.png",
                "alt": "Thomas morice back to studies",
                "title": "Thomas morice back to studies",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
      `}</picture>{`
    `}</span></p>
      </ImageClipped>
    </Section>
    <Section mdxType="Section">
      <h2>{`University of Strasbourg`}</h2>
      <p>{`Going back to school at the age of twenty-four years old was a pretty big challenge, especially since my educational background was weaker than the other students.`}</p>
      <p>{`Despite that, being in this university wasn't a random choice, I wanted it! Thanks to that state of mind, for the first time, I was learning subjects, concepts, a new job, without difficulties.`}</p>
      <p>{`I graduated with a Bachelor of Science three years later, and on the third year I had the opportunity to do it through an apprenticeship for my first professional experience as a developer.`}</p>
    </Section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      